var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('blockquote',{attrs:{"data-external":"rich-text-display-blockquote"}},[_c('RichTextEditor',{attrs:{"content":_vm.richTextContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }